import {LanguageConstants} from  './language.constants'
const {
    FETCHING_LANGUAGE_SUCCESS
} = LanguageConstants

const defaultState = {
    language:'spanish'
}


const LanguageReducer = (state = defaultState , action) => {
    switch (action.type) {
        case FETCHING_LANGUAGE_SUCCESS:
            return{
                ...state,
                language:action.language,
        };
        default:
        return state;
    }
};

export  default  LanguageReducer;